module.exports = __webpack_public_path__ + "static/media/TRIAL 2-if-wrong.7be64265.mp3";